import useModalClickOutside from "utils/useModalClickOutside";
import { useTranslation } from "next-i18next";
import BottomModal from "components/common/Modal/BottomModal";
import { TYPO } from "styles/Typo";
import Icon, { ICONS } from "components/common/Icons";
import GrayToggleButton from "components/common/buttons/toggle/GrayToggleButton";
import { useRouter } from "next/router";

function PortfolioSettingModal({
  setModalOpen,
  isModalOpen,
  toggleDispatch,
  toggleState,
  from = "main",
}: any) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { t } = useTranslation("portfolio");
  const router = useRouter();
  return (
    <BottomModal isOpen={isModalOpen} modalRef={modalRef} containerClass="">
      <div className="flex flex-col gap-4 w-full">
        <span className={`${TYPO.TYPO4_SB} text-gray80`}>
          {router.locale === "ko" ? "프트폴리오 설정" : "Portfolio Setting"}
        </span>
        <div className="flex flex-col gap-2  w-full">
          <div
            className="flex items-center gap-3 py-[10px] cursor-pointer"
            onClick={() => {
              if (from === "main") {
                router.push("/portfolio/setting");
              } else if (from === "detail") {
                router.push(`/portfolio/edit?pf=${router.query.pf}`);
              }
            }}
          >
            <span className={`${TYPO.TYPO5_1_MD} text-gray70 grow`}>
              {t("editInvestment")}
            </span>
            <div className="shrink-0">
              <Icon name={ICONS.FORWARD} fill="gray30" width={16} height={16} />
            </div>
          </div>
          <div className="flex items-center gap-3 py-[10px]">
            <span className={`${TYPO.TYPO5_1_MD} text-gray70 grow`}>
              {t("defaultCurrentcy")}
            </span>
            <div className="shrink-0">
              <GrayToggleButton
                isToggled={toggleState === "KRW"}
                leftText={
                  router.locale === "ko" ? "외화" : "Currency Denomination"
                }
                rightText={router.locale === "ko" ? "원화" : "USD"}
                onClick={() => {
                  toggleDispatch({
                    type: "SET_BASECURRENCY",
                    payload: toggleState === "KRW" ? "USD" : "KRW",
                  });
                  // toggleDispatch({ type: "TOGGLE" });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </BottomModal>
  );
}

export default PortfolioSettingModal;
